import { Link } from 'react-router-dom';
import { GenericCatalogTable } from "../../../components/generic-catalog-table";
import { ScrollReveal } from "../../../components/scroll-reveal";
import { SEBI_CSCRF_CONTROLS, SEBI_PILLARS } from "../../../data/sebi-cscrf-controls";

export default function SebiCscrfFramework() {
  const columns = [
    { accessorKey: "controlId", header: "Control ID", size: 120 },
    { accessorKey: "pillar", header: "Pillar", size: 220 },
    { accessorKey: "objective", header: "Control Objective", size: 200 },
    { accessorKey: "requirement", header: "Detailed Requirement", size: 320 },
    { accessorKey: "guidance", header: "Implementation Guidance", size: 260 },
    { accessorKey: "metrics", header: "Metrics/KRIs", size: 180 },
    { accessorKey: "evidence", header: "Evidence", size: 220 },
    { accessorKey: "testMethod", header: "Testing Method", size: 200 },
    { accessorKey: "frequency", header: "Frequency", size: 140 },
    { accessorKey: "owner", header: "Owner", size: 160 },
    { accessorKey: "observations", header: "Audit Observations", size: 240 },
    { accessorKey: "severity", header: "Severity", size: 120 },
    { accessorKey: "automation", header: "Automation", size: 140 },
  ];
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            Indian Regulatory Frameworks / SEBI
          </div>

          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            SEBI Cyber Security &
            <br />
            Cyber Resilience Framework
          </h1>

          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Comprehensive security framework for stock exchanges, depositories,
            clearing corporations, and registered intermediaries.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#sebi-catalog"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Download CSCRF Catalog
            </a>
            <a
              href="#pillar-structure"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              View Pillar Structure
            </a>
            <Link
              to="/frameworks/india/rbi"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl px-5 text-sm font-semibold text-[color:var(--text-link)] transition-colors hover:text-text-primary"
            >
              Back to RBI →
            </Link>
          </div>

          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { k: "Pillars", v: "11" },
              { k: "Controls", v: "100+" },
              { k: "Updated", v: "2024" },
            ].map((s) => (
              <div key={s.k} className="glass-card sheen p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  {s.k}
                </div>
                <div className="mt-2 font-[family:var(--font-space-grotesk)] text-3xl font-semibold text-text-primary">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-secondary py-20" id="pillar-structure">
        <div className="container-ivalue">
          <ScrollReveal>
            <div className="glass-card p-6">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                CSCRF pillar structure
              </div>
              <h2 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">
                11 pillars
              </h2>

              <div className="mt-6 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {SEBI_PILLARS.map((p) => (
                  <div
                    key={p}
                    className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary"
                  >
                    {p}
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="bg-background-primary py-20" id="sebi-catalog">
        <div className="container-ivalue">
          <ScrollReveal>
            <div>
              <h2 className="text-3xl font-extrabold tracking-[-0.02em] text-text-primary md:text-5xl">
                SEBI CSCRF control catalog
              </h2>
              <p className="mt-3 max-w-3xl text-lg text-text-secondary">
                Seeded with sample controls (extendable to 100+ in the next phase).
              </p>
            </div>
          </ScrollReveal>

          <div className="mt-10">
            <GenericCatalogTable
              data={SEBI_CSCRF_CONTROLS}
              columns={columns}
              csvColumns={[
                { header: "Control ID", accessorKey: "controlId" },
                { header: "Pillar", accessorKey: "pillar" },
                { header: "Objective", accessorKey: "objective" },
                { header: "Requirement", accessorKey: "requirement" },
                { header: "Guidance", accessorKey: "guidance" },
                { header: "Metrics", accessorKey: "metrics" },
                { header: "Evidence", accessorKey: "evidence" },
                { header: "Test Method", accessorKey: "testMethod" },
                { header: "Frequency", accessorKey: "frequency" },
                { header: "Owner", accessorKey: "owner" },
                { header: "Observations", accessorKey: "observations" },
                { header: "Severity", accessorKey: "severity" },
                { header: "Automation", accessorKey: "automation" },
              ]}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
